import { render, staticRenderFns } from "./PlaylistItemList.vue?vue&type=template&id=bf1444c2&scoped=true"
import script from "./PlaylistItemList.vue?vue&type=script&lang=js"
export * from "./PlaylistItemList.vue?vue&type=script&lang=js"
import style0 from "./PlaylistItemList.vue?vue&type=style&index=0&id=bf1444c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf1444c2",
  null
  
)

export default component.exports